import { render, staticRenderFns } from "./NFCPopup.vue?vue&type=template&id=0034b0fb&scoped=true"
import script from "./NFCPopup.vue?vue&type=script&lang=js"
export * from "./NFCPopup.vue?vue&type=script&lang=js"
import style0 from "./NFCPopup.vue?vue&type=style&index=0&id=0034b0fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0034b0fb",
  null
  
)

export default component.exports